"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodCardStatus = exports.PaymentMethodType = exports.PaymentMethodCardType = void 0;
var PaymentMethodCardType;
(function (PaymentMethodCardType) {
    PaymentMethodCardType["AMEX"] = "american express";
    PaymentMethodCardType["DISCOVER"] = "discover";
    PaymentMethodCardType["MASTER_CARD"] = "mastercard";
    PaymentMethodCardType["MAESTRO"] = "maestro";
    PaymentMethodCardType["VISA"] = "visa";
})(PaymentMethodCardType = exports.PaymentMethodCardType || (exports.PaymentMethodCardType = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["ACH"] = "ACH";
    PaymentMethodType["CHECK"] = "Check";
    PaymentMethodType["CREDIT_CARD"] = "Credit Card";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var PaymentMethodCardStatus;
(function (PaymentMethodCardStatus) {
    PaymentMethodCardStatus["APPROVED"] = "Approved";
})(PaymentMethodCardStatus = exports.PaymentMethodCardStatus || (exports.PaymentMethodCardStatus = {}));
